import { render } from "./DetailAddressBox.vue?vue&type=template&id=a4fa6f48&scoped=true"
import script from "./DetailAddressBox.vue?vue&type=script&lang=ts"
export * from "./DetailAddressBox.vue?vue&type=script&lang=ts"

import "./DetailAddressBox.vue?vue&type=style&index=0&id=a4fa6f48&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-a4fa6f48"

export default script